import { render, staticRenderFns } from "./muladdModal.vue?vue&type=template&id=37e24de4&scoped=true&"
import script from "./muladdModal.vue?vue&type=script&lang=js&"
export * from "./muladdModal.vue?vue&type=script&lang=js&"
import style0 from "./muladdModal.vue?vue&type=style&index=0&id=37e24de4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e24de4",
  null
  
)

export default component.exports